import type { NavigateFunction } from 'react-router-dom';

import type { News } from 'hb-builder/components/BuilderComponents/dynamic/types/news';
import type { AuthenticationIds } from 'hb-builder/types/config/AuthenticationIds';
import { goToModuleDetailPage } from 'hb-builder/utils/goToModuleDetailPage';

export const mapNewsList = ({
  ids,
  isBackOffice,
  navigate,
  news,
  whiteLabelUrl,
}: {
  ids?: AuthenticationIds;
  isBackOffice: boolean;
  navigate?: NavigateFunction;
  news: News[];
  whiteLabelUrl?: string | null;
}) =>
  news?.map((oneNews) => {
    const {
      id,
      content,
      new_cover_picture: newCoverPicture,
      published_at: publishedAt,
      seo_description: seoDescription,
      seo_title: seoTitle,
      subject,
    } = oneNews;

    return {
      coverPicture: newCoverPicture.medium_url,
      description: seoDescription || content,
      id,
      onClick: () =>
        ids &&
        navigate &&
        goToModuleDetailPage({
          ids,
          isBackOffice,
          navigate,
          news: oneNews,
          whiteLabelUrl,
        }),
      publishedAt,
      seoTitle,
      subject,
    };
  });
